import BackendService from "../../../../src/services/backend.service";
import { setDefaultDatePickerStorage, setDefaultFiltersStorage } from "../../../../src/services/auth.service";

class SharedUtils {

    apiPost = async (endpoint, jsondata, reload = false, withmsg = false, downloadfile = false, options = {}, is_file = false) => {
        return await BackendService.postJSON(endpoint, jsondata, reload, withmsg, downloadfile, options, is_file).then(async (response) => {
            if(response || endpoint === "admin_saas_agreement"){
                return await Promise.all([response]).then((arrList) => {
                    return arrList;
                });
            } 
            else if(typeof response === "boolean") {
                return response;
            }
            else return null;
        });
    };

    apiGet = async (endpoint, params = {}, reload = false, withmsg = false, downloadfile = false, options = {}, is_file = false) => {
        return await BackendService.getJSON(endpoint, params, reload, withmsg, downloadfile, options, is_file).then(async (response) => {
            if (response || endpoint === "admin_saas_agreement") {
                return await Promise.all([response]).then((arrList) => {
                    return arrList;
                });
            } 
            else if (typeof response === "boolean") {
                return response;
            }
            else return null;
        });
    };

    apiDownload = async (endpoint, jsondata) => {
        return await BackendService.postDownfile(endpoint, jsondata).then(async (response) => {
            return await Promise.all([response]).then((arrList) => {
                return arrList;
            });
        });
    };


    filePost = async (endpoint, file, reload = false, withmsg = false, downloadfile = false, options = {}) => {
        return await BackendService.postJSON(endpoint, file, reload, withmsg, downloadfile, options, true).then(async (response) => {
            return await Promise.all([response]).then((arrList) => {
                return arrList;
            });
        });
    };

    /**
     * Parse API / mock timestamps into a Date.
     * Supports ISO, RFC GMT strings ("Tue, 7 Aug 2026 23:48:55 GMT"), and
     * timezone-naive "YYYY-MM-DD HH:mm:ss" / "YYYY-MM-DDTHH:mm:ss" (treated as UTC).
     */
    parseApiDate = (date) => {
        if (date == null || date === '') return null;
        if (date instanceof Date) {
            return Number.isNaN(date.getTime()) ? null : date;
        }
        if (typeof date === 'number') {
            const d = new Date(date);
            return Number.isNaN(d.getTime()) ? null : d;
        }

        let s = String(date).trim();
        if (!s) return null;

        // Normalize space-separated datetime and treat timezone-naive values as UTC.
        const hasExplicitTz = /(?:[zZ]|GMT|UTC|[+-]\d{2}:?\d{2})$/.test(s) || /[+-]\d{2}:\d{2}\b/.test(s);
        if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/.test(s)) {
            s = s.replace(/^(\d{4}-\d{2}-\d{2})\s+/, '$1T');
            if (!hasExplicitTz) s = `${s}Z`;
        }

        const parsed = new Date(s);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    getLocalTimeZone = (date) => {
        const parsed = this.parseApiDate(date);
        if (!parsed) return '';

        const dateformat = {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        };
        // Get the local time zone offset in minutes (UTC - local, so e.g. IST gives -330)
        const timeZoneOffsetMinutes = new Date().getTimezoneOffset();
        const absOffsetMinutes = Math.abs(timeZoneOffsetMinutes);

        // Convert the offset to hours and minutes, and determine sign
        const sign = timeZoneOffsetMinutes <= 0 ? '+' : '-';
        const hours = Math.floor(absOffsetMinutes / 60);
        const minutes = absOffsetMinutes % 60;

        // Create a string representation of the time zone (e.g. GMT+5:30)
        const timeZoneString = minutes > 0
            ? `GMT${sign}${hours}:${minutes.toString().padStart(2, '0')}`
            : `GMT${sign}${hours}`;

        // toLocaleString (not toLocaleDateString) so hour/minute are reliably applied
        return `${parsed.toLocaleString('en-US', dateformat)} (${timeZoneString})`;
    };

    doSsoLogin = async (id, token, type) => {

         
        let x = await this.apiPost("validate_sso/" + type, { "token": token, client_id: id.clientid }, false, true);

        if (x[0].data['msg'] == 'OK') {
            localStorage.setItem("reduxState",
                JSON.stringify({
                    "auth": { "username": x[0].data['username'], "email": x[0].data['email'], "token": x[0].data['token'], "refresh": x[0].data['refresh'] },
                    "header": { "isOpen": false }
                }));
            localStorage.setItem("client_name", id['client_name']);

            if (window.location.href.includes('login')) {
                window.location = "/";

            }
            else {
                window.location = window.location;
            }
   
        }
        else {
            return x[0]['msg'];
        }
    }

    isValidDomain = (domain, allow_path, allow_schema) => {
        const domainRegex =
          /^(?!:\/\/)(?:(?:[a-zA-Z0-9-_]+[a-zA-Z0-9-_.]*\.)?[a-zA-Z]{1,}|(?:\d{1,3}\.){3}\d{1,3})$/i;
        const domainWithPathRegex =
          /^(?!:\/\/)([a-zA-Z0-9-_]+(\.[a-zA-Z0-9-_]+)*\.)?[a-zA-Z0-9]{1,}((\/[\w.-]*)*(?:\?[\w=&.-]*)?(?:#[\w-]*)?)?$/;
        const domainWithPathRegexWithSchema =
         /^(https?:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{1,}?/i


        if (allow_schema) {
            return domainWithPathRegexWithSchema.test(domain);
        }
        else if (allow_path){
            return domainWithPathRegex.test(domain);
        } else {
            return domainRegex.test(domain);
        }
      };

        extractHostname = (input) => {
            if (!input || typeof input !== "string") return null;

            try {
                let url = input.match(/^https?:\/\//) ? input : "http://" + input;
                let hostname = new URL(url).hostname;
                return hostname || input;
            } catch (e) {
                return input;
            }
        }

    cleanBaseUrl(url) {
        return url.replace(/\/v1\/?.*$/, '/');
    }

}



export default new SharedUtils();
